import { GetterTree } from 'vuex';
import { RootState } from '@/interface/store/';
import { Auth } from '@/interface/store/auth';

export const getters: GetterTree<Auth, RootState> = {
  getterAuth: (state) => state,
  getterIsEmail: (state) => state.isEmail,
  getterIsRegister: (state) => state.isRegister,
  getterIsAuth: (state) => state.isAuth,
  getterAuthUserId: (state) => state.id,
  getterAuthLastGroupId: (state) => state.lastGroupId,
};
